export default [
  {
    id: 151603269,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTE2MDMyNjk=",
    name: "1.StartupSite-wFlex-",
    full_name: "nfragiskatos/1.StartupSite-wFlex-",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/1.StartupSite-wFlex-",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/1.StartupSite-wFlex-/deployments",
    created_at: "2018-10-04T16:34:03Z",
    updated_at: "2018-10-04T20:12:57Z",
    pushed_at: "2018-10-04T20:12:55Z",
    git_url: "git://github.com/nfragiskatos/1.StartupSite-wFlex-.git",
    ssh_url: "git@github.com:nfragiskatos/1.StartupSite-wFlex-.git",
    clone_url: "https://github.com/nfragiskatos/1.StartupSite-wFlex-.git",
    svn_url: "https://github.com/nfragiskatos/1.StartupSite-wFlex-",
    homepage: null,
    size: 1028,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 152270522,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTIyNzA1MjI=",
    name: "2.Todo_SPA",
    full_name: "nfragiskatos/2.Todo_SPA",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/2.Todo_SPA",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/2.Todo_SPA",
    forks_url: "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/2.Todo_SPA/deployments",
    created_at: "2018-10-09T14:56:11Z",
    updated_at: "2018-10-11T00:32:51Z",
    pushed_at: "2018-10-11T00:32:50Z",
    git_url: "git://github.com/nfragiskatos/2.Todo_SPA.git",
    ssh_url: "git@github.com:nfragiskatos/2.Todo_SPA.git",
    clone_url: "https://github.com/nfragiskatos/2.Todo_SPA.git",
    svn_url: "https://github.com/nfragiskatos/2.Todo_SPA",
    homepage: null,
    size: 9,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 149534572,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDk1MzQ1NzI=",
    name: "2_Terminal_Hacker",
    full_name: "nfragiskatos/2_Terminal_Hacker",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/2_Terminal_Hacker",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/2_Terminal_Hacker/deployments",
    created_at: "2018-09-20T01:38:20Z",
    updated_at: "2018-09-22T01:27:34Z",
    pushed_at: "2018-09-22T01:27:29Z",
    git_url: "git://github.com/nfragiskatos/2_Terminal_Hacker.git",
    ssh_url: "git@github.com:nfragiskatos/2_Terminal_Hacker.git",
    clone_url: "https://github.com/nfragiskatos/2_Terminal_Hacker.git",
    svn_url: "https://github.com/nfragiskatos/2_Terminal_Hacker",
    homepage: null,
    size: 79391,
    stargazers_count: 0,
    watchers_count: 0,
    language: "C#",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 209417362,
    node_id: "MDEwOlJlcG9zaXRvcnkyMDk0MTczNjI=",
    name: "About_Me_Kotlin",
    full_name: "nfragiskatos/About_Me_Kotlin",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/About_Me_Kotlin",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/About_Me_Kotlin/deployments",
    created_at: "2019-09-18T22:51:36Z",
    updated_at: "2019-09-23T23:45:38Z",
    pushed_at: "2019-09-23T23:45:35Z",
    git_url: "git://github.com/nfragiskatos/About_Me_Kotlin.git",
    ssh_url: "git@github.com:nfragiskatos/About_Me_Kotlin.git",
    clone_url: "https://github.com/nfragiskatos/About_Me_Kotlin.git",
    svn_url: "https://github.com/nfragiskatos/About_Me_Kotlin",
    homepage: null,
    size: 222,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 213774022,
    node_id: "MDEwOlJlcG9zaXRvcnkyMTM3NzQwMjI=",
    name: "andfun-kotlin-dessert-pusher",
    full_name: "nfragiskatos/andfun-kotlin-dessert-pusher",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/andfun-kotlin-dessert-pusher",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-dessert-pusher/deployments",
    created_at: "2019-10-08T23:13:13Z",
    updated_at: "2019-10-09T22:57:40Z",
    pushed_at: "2019-10-09T22:57:38Z",
    git_url: "git://github.com/nfragiskatos/andfun-kotlin-dessert-pusher.git",
    ssh_url: "git@github.com:nfragiskatos/andfun-kotlin-dessert-pusher.git",
    clone_url:
      "https://github.com/nfragiskatos/andfun-kotlin-dessert-pusher.git",
    svn_url: "https://github.com/nfragiskatos/andfun-kotlin-dessert-pusher",
    homepage: null,
    size: 1861,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 214303204,
    node_id: "MDEwOlJlcG9zaXRvcnkyMTQzMDMyMDQ=",
    name: "andfun-kotlin-guess-it",
    full_name: "nfragiskatos/andfun-kotlin-guess-it",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/andfun-kotlin-guess-it",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-guess-it/deployments",
    created_at: "2019-10-10T23:24:55Z",
    updated_at: "2019-10-12T22:23:37Z",
    pushed_at: "2019-10-12T22:23:35Z",
    git_url: "git://github.com/nfragiskatos/andfun-kotlin-guess-it.git",
    ssh_url: "git@github.com:nfragiskatos/andfun-kotlin-guess-it.git",
    clone_url: "https://github.com/nfragiskatos/andfun-kotlin-guess-it.git",
    svn_url: "https://github.com/nfragiskatos/andfun-kotlin-guess-it",
    homepage: null,
    size: 238,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 214846101,
    node_id: "MDEwOlJlcG9zaXRvcnkyMTQ4NDYxMDE=",
    name: "andfun-kotlin-sleep-tracker",
    full_name: "nfragiskatos/andfun-kotlin-sleep-tracker",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/andfun-kotlin-sleep-tracker",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker/deployments",
    created_at: "2019-10-13T15:38:40Z",
    updated_at: "2019-10-28T00:49:56Z",
    pushed_at: "2019-10-28T00:49:54Z",
    git_url: "git://github.com/nfragiskatos/andfun-kotlin-sleep-tracker.git",
    ssh_url: "git@github.com:nfragiskatos/andfun-kotlin-sleep-tracker.git",
    clone_url:
      "https://github.com/nfragiskatos/andfun-kotlin-sleep-tracker.git",
    svn_url: "https://github.com/nfragiskatos/andfun-kotlin-sleep-tracker",
    homepage: null,
    size: 453,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 217731706,
    node_id: "MDEwOlJlcG9zaXRvcnkyMTc3MzE3MDY=",
    name: "andfun-kotlin-sleep-tracker-with-recyclerview",
    full_name: "nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url:
      "https://github.com/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview/deployments",
    created_at: "2019-10-26T15:48:25Z",
    updated_at: "2019-10-26T15:48:59Z",
    pushed_at: "2019-10-26T15:48:57Z",
    git_url:
      "git://github.com/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview.git",
    ssh_url:
      "git@github.com:nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview.git",
    clone_url:
      "https://github.com/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview.git",
    svn_url:
      "https://github.com/nfragiskatos/andfun-kotlin-sleep-tracker-with-recyclerview",
    homepage: null,
    size: 314,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 504333626,
    node_id: "R_kgDOHg-FOg",
    name: "android-coroutines-course",
    full_name: "nfragiskatos/android-coroutines-course",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/android-coroutines-course",
    description:
      "Initial code state for this Udemy course https://www.udemy.com/course/kotlin-coroutines-in-android/",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/android-coroutines-course",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/android-coroutines-course/deployments",
    created_at: "2022-06-16T23:26:05Z",
    updated_at: "2022-06-16T23:26:49Z",
    pushed_at: "2022-06-16T23:26:46Z",
    git_url: "git://github.com/nfragiskatos/android-coroutines-course.git",
    ssh_url: "git@github.com:nfragiskatos/android-coroutines-course.git",
    clone_url: "https://github.com/nfragiskatos/android-coroutines-course.git",
    svn_url: "https://github.com/nfragiskatos/android-coroutines-course",
    homepage: null,
    size: 130,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 359627380,
    node_id: "MDEwOlJlcG9zaXRvcnkzNTk2MjczODA=",
    name: "Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo",
    full_name:
      "nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo",
    description: "Toy App for Coroutine Demo",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo/deployments",
    created_at: "2021-04-19T23:37:58Z",
    updated_at: "2021-04-20T03:51:40Z",
    pushed_at: "2021-04-20T03:51:38Z",
    git_url:
      "git://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo.git",
    ssh_url:
      "git@github.com:nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo.git",
    clone_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo.git",
    svn_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_CoroutinesDemo",
    homepage: null,
    size: 134,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 358429887,
    node_id: "MDEwOlJlcG9zaXRvcnkzNTg0Mjk4ODc=",
    name: "Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1",
    full_name:
      "nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1",
    description: "Toy App for Data Binding example",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1/deployments",
    created_at: "2021-04-16T00:32:18Z",
    updated_at: "2021-04-17T15:51:17Z",
    pushed_at: "2021-04-17T15:51:15Z",
    git_url:
      "git://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1.git",
    ssh_url:
      "git@github.com:nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1.git",
    clone_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1.git",
    svn_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_BindingDemo1",
    homepage: null,
    size: 141,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 358952331,
    node_id: "MDEwOlJlcG9zaXRvcnkzNTg5NTIzMzE=",
    name: "Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo",
    full_name:
      "nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo",
    description: "Toy App for Navigation Architecture Components",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo/deployments",
    created_at: "2021-04-17T18:21:58Z",
    updated_at: "2021-04-18T16:39:07Z",
    pushed_at: "2021-04-18T16:39:05Z",
    git_url:
      "git://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo.git",
    ssh_url:
      "git@github.com:nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo.git",
    clone_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo.git",
    svn_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_project-01_NavDemo",
    homepage: null,
    size: 153,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 359607396,
    node_id: "MDEwOlJlcG9zaXRvcnkzNTk2MDczOTY=",
    name: "Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo",
    full_name:
      "nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo",
    description: "Toy App For Messing With RecyclerView",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo/deployments",
    created_at: "2021-04-19T21:48:25Z",
    updated_at: "2021-04-19T22:31:00Z",
    pushed_at: "2021-04-19T22:30:58Z",
    git_url:
      "git://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo.git",
    ssh_url:
      "git@github.com:nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo.git",
    clone_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo.git",
    svn_url:
      "https://github.com/nfragiskatos/Android-Jetpack-Clean-Architecture-Testing-Masterclass_RecyclerViewDemo",
    homepage: null,
    size: 135,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 709776952,
    node_id: "R_kgDOKk5WOA",
    name: "AndroidLaunchModes",
    full_name: "nfragiskatos/AndroidLaunchModes",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/AndroidLaunchModes",
    description:
      "Sample project to demonstrate how different launch modes work in Android",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/AndroidLaunchModes/deployments",
    created_at: "2023-10-25T11:32:34Z",
    updated_at: "2023-11-16T14:13:28Z",
    pushed_at: "2023-11-07T23:14:50Z",
    git_url: "git://github.com/nfragiskatos/AndroidLaunchModes.git",
    ssh_url: "git@github.com:nfragiskatos/AndroidLaunchModes.git",
    clone_url: "https://github.com/nfragiskatos/AndroidLaunchModes.git",
    svn_url: "https://github.com/nfragiskatos/AndroidLaunchModes",
    homepage:
      "https://blog.nicholasfragiskatos.dev/launch-modes-in-android-with-examples",
    size: 112,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ["android", "android-framework", "android-launch-mode"],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 210955966,
    node_id: "MDEwOlJlcG9zaXRvcnkyMTA5NTU5NjY=",
    name: "AndroidTrivia",
    full_name: "nfragiskatos/AndroidTrivia",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/AndroidTrivia",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/AndroidTrivia",
    forks_url: "https://api.github.com/repos/nfragiskatos/AndroidTrivia/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/AndroidTrivia/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/AndroidTrivia/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/AndroidTrivia/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/AndroidTrivia/deployments",
    created_at: "2019-09-25T23:03:03Z",
    updated_at: "2019-10-05T17:47:53Z",
    pushed_at: "2019-10-05T17:47:51Z",
    git_url: "git://github.com/nfragiskatos/AndroidTrivia.git",
    ssh_url: "git@github.com:nfragiskatos/AndroidTrivia.git",
    clone_url: "https://github.com/nfragiskatos/AndroidTrivia.git",
    svn_url: "https://github.com/nfragiskatos/AndroidTrivia",
    homepage: null,
    size: 378,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 703432926,
    node_id: "R_kgDOKe2I3g",
    name: "Anki-Android",
    full_name: "nfragiskatos/Anki-Android",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/Anki-Android",
    description:
      "AnkiDroid: Anki flashcards on Android. Your secret trick to achieve superhuman information retention.",
    fork: true,
    url: "https://api.github.com/repos/nfragiskatos/Anki-Android",
    forks_url: "https://api.github.com/repos/nfragiskatos/Anki-Android/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/Anki-Android/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/Anki-Android/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/Anki-Android/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/Anki-Android/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/Anki-Android/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Anki-Android/deployments",
    created_at: "2023-10-11T08:32:35Z",
    updated_at: "2023-10-24T14:34:59Z",
    pushed_at: "2023-12-12T08:23:03Z",
    git_url: "git://github.com/nfragiskatos/Anki-Android.git",
    ssh_url: "git@github.com:nfragiskatos/Anki-Android.git",
    clone_url: "https://github.com/nfragiskatos/Anki-Android.git",
    svn_url: "https://github.com/nfragiskatos/Anki-Android",
    homepage: "",
    size: 220245,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "gpl-3.0",
      name: "GNU General Public License v3.0",
      spdx_id: "GPL-3.0",
      url: "https://api.github.com/licenses/gpl-3.0",
      node_id: "MDc6TGljZW5zZTk=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 150199074,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTAxOTkwNzQ=",
    name: "AuthDemo",
    full_name: "nfragiskatos/AuthDemo",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/AuthDemo",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/AuthDemo",
    forks_url: "https://api.github.com/repos/nfragiskatos/AuthDemo/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/AuthDemo/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/AuthDemo/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/AuthDemo/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/AuthDemo/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/AuthDemo/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/AuthDemo/deployments",
    created_at: "2018-09-25T02:55:26Z",
    updated_at: "2018-09-25T03:47:41Z",
    pushed_at: "2018-09-25T03:47:39Z",
    git_url: "git://github.com/nfragiskatos/AuthDemo.git",
    ssh_url: "git@github.com:nfragiskatos/AuthDemo.git",
    clone_url: "https://github.com/nfragiskatos/AuthDemo.git",
    svn_url: "https://github.com/nfragiskatos/AuthDemo",
    homepage: null,
    size: 4,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 614646758,
    node_id: "R_kgDOJKLD5g",
    name: "BluetoothChat",
    full_name: "nfragiskatos/BluetoothChat",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/BluetoothChat",
    description: "Toy app for messing with the bluetooth APIs",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/BluetoothChat",
    forks_url: "https://api.github.com/repos/nfragiskatos/BluetoothChat/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/BluetoothChat/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/BluetoothChat/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/BluetoothChat/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/BluetoothChat/deployments",
    created_at: "2023-03-16T02:40:22Z",
    updated_at: "2023-03-16T02:40:37Z",
    pushed_at: "2023-03-19T18:00:58Z",
    git_url: "git://github.com/nfragiskatos/BluetoothChat.git",
    ssh_url: "git@github.com:nfragiskatos/BluetoothChat.git",
    clone_url: "https://github.com/nfragiskatos/BluetoothChat.git",
    svn_url: "https://github.com/nfragiskatos/BluetoothChat",
    homepage: null,
    size: 113,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 729924738,
    node_id: "R_kgDOK4HEgg",
    name: "BottleBuddy",
    full_name: "nfragiskatos/BottleBuddy",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/BottleBuddy",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/BottleBuddy",
    forks_url: "https://api.github.com/repos/nfragiskatos/BottleBuddy/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/BottleBuddy/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/BottleBuddy/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/BottleBuddy/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/BottleBuddy/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/BottleBuddy/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/BottleBuddy/deployments",
    created_at: "2023-12-10T19:09:39Z",
    updated_at: "2024-01-08T21:32:36Z",
    pushed_at: "2024-01-13T01:43:48Z",
    git_url: "git://github.com/nfragiskatos/BottleBuddy.git",
    ssh_url: "git@github.com:nfragiskatos/BottleBuddy.git",
    clone_url: "https://github.com/nfragiskatos/BottleBuddy.git",
    svn_url: "https://github.com/nfragiskatos/BottleBuddy",
    homepage: null,
    size: 1820,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "gpl-3.0",
      name: "GNU General Public License v3.0",
      spdx_id: "GPL-3.0",
      url: "https://api.github.com/licenses/gpl-3.0",
      node_id: "MDc6TGljZW5zZTk=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 683111820,
    node_id: "R_kgDOKLd1jA",
    name: "Coda-Pizza",
    full_name: "nfragiskatos/Coda-Pizza",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/Coda-Pizza",
    description: "Toy App for Compose",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Coda-Pizza",
    forks_url: "https://api.github.com/repos/nfragiskatos/Coda-Pizza/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/Coda-Pizza/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/Coda-Pizza/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/Coda-Pizza/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/Coda-Pizza/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/Coda-Pizza/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Coda-Pizza/deployments",
    created_at: "2023-08-25T16:18:48Z",
    updated_at: "2023-08-25T16:18:58Z",
    pushed_at: "2023-09-05T15:24:54Z",
    git_url: "git://github.com/nfragiskatos/Coda-Pizza.git",
    ssh_url: "git@github.com:nfragiskatos/Coda-Pizza.git",
    clone_url: "https://github.com/nfragiskatos/Coda-Pizza.git",
    svn_url: "https://github.com/nfragiskatos/Coda-Pizza",
    homepage: null,
    size: 865,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 210723760,
    node_id: "MDEwOlJlcG9zaXRvcnkyMTA3MjM3NjA=",
    name: "ColorMyViews",
    full_name: "nfragiskatos/ColorMyViews",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/ColorMyViews",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/ColorMyViews",
    forks_url: "https://api.github.com/repos/nfragiskatos/ColorMyViews/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/ColorMyViews/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/ColorMyViews/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/ColorMyViews/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/ColorMyViews/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/ColorMyViews/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/ColorMyViews/deployments",
    created_at: "2019-09-25T00:46:00Z",
    updated_at: "2019-09-25T04:21:51Z",
    pushed_at: "2019-09-25T04:21:49Z",
    git_url: "git://github.com/nfragiskatos/ColorMyViews.git",
    ssh_url: "git@github.com:nfragiskatos/ColorMyViews.git",
    clone_url: "https://github.com/nfragiskatos/ColorMyViews.git",
    svn_url: "https://github.com/nfragiskatos/ColorMyViews",
    homepage: null,
    size: 221,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 660017517,
    node_id: "R_kgDOJ1cRbQ",
    name: "CriminalIntent",
    full_name: "nfragiskatos/CriminalIntent",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/CriminalIntent",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/CriminalIntent",
    forks_url: "https://api.github.com/repos/nfragiskatos/CriminalIntent/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/CriminalIntent/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/CriminalIntent/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/CriminalIntent/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/CriminalIntent/deployments",
    created_at: "2023-06-29T04:11:05Z",
    updated_at: "2023-08-24T15:51:54Z",
    pushed_at: "2023-10-20T15:22:19Z",
    git_url: "git://github.com/nfragiskatos/CriminalIntent.git",
    ssh_url: "git@github.com:nfragiskatos/CriminalIntent.git",
    clone_url: "https://github.com/nfragiskatos/CriminalIntent.git",
    svn_url: "https://github.com/nfragiskatos/CriminalIntent",
    homepage: null,
    size: 204,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 485988781,
    node_id: "R_kgDOHPeZrQ",
    name: "CryptoCurrencyBrowswer",
    full_name: "nfragiskatos/CryptoCurrencyBrowswer",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/CryptoCurrencyBrowswer",
    description:
      "Toy App for practicing Android development, mvvm architecture, and compose",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/CryptoCurrencyBrowswer/deployments",
    created_at: "2022-04-27T00:15:42Z",
    updated_at: "2022-05-01T23:33:56Z",
    pushed_at: "2022-05-01T23:27:39Z",
    git_url: "git://github.com/nfragiskatos/CryptoCurrencyBrowswer.git",
    ssh_url: "git@github.com:nfragiskatos/CryptoCurrencyBrowswer.git",
    clone_url: "https://github.com/nfragiskatos/CryptoCurrencyBrowswer.git",
    svn_url: "https://github.com/nfragiskatos/CryptoCurrencyBrowswer",
    homepage: "",
    size: 133,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "android-application",
      "android-development",
      "compose-android",
      "composer-library",
      "coroutines-android",
      "coroutines-flow",
      "kotlin",
      "kotlin-android",
      "mvvm",
      "mvvm-android",
      "mvvm-architecture",
      "retrofit",
      "retrofit2",
      "retrofit2-coroutines",
      "retrofit2-kotlin",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 257752425,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTc3NTI0MjU=",
    name: "Design_Patterns",
    full_name: "nfragiskatos/Design_Patterns",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/Design_Patterns",
    description:
      "Practicing and Learning Design Patterns (Gang of 4) in Kotlin",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Design_Patterns",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/Design_Patterns/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns/deployments",
    created_at: "2020-04-22T00:51:41Z",
    updated_at: "2020-04-22T01:00:52Z",
    pushed_at: "2020-04-22T00:51:52Z",
    git_url: "git://github.com/nfragiskatos/Design_Patterns.git",
    ssh_url: "git@github.com:nfragiskatos/Design_Patterns.git",
    clone_url: "https://github.com/nfragiskatos/Design_Patterns.git",
    svn_url: "https://github.com/nfragiskatos/Design_Patterns",
    homepage: "",
    size: 1,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 257754040,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTc3NTQwNDA=",
    name: "Design_Patterns_Java",
    full_name: "nfragiskatos/Design_Patterns_Java",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/Design_Patterns_Java",
    description: "Practicing and Learning Design Patterns (Gang of 4) in Java",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Design_Patterns_Java/deployments",
    created_at: "2020-04-22T01:01:02Z",
    updated_at: "2020-05-20T21:58:28Z",
    pushed_at: "2022-05-25T07:07:44Z",
    git_url: "git://github.com/nfragiskatos/Design_Patterns_Java.git",
    ssh_url: "git@github.com:nfragiskatos/Design_Patterns_Java.git",
    clone_url: "https://github.com/nfragiskatos/Design_Patterns_Java.git",
    svn_url: "https://github.com/nfragiskatos/Design_Patterns_Java",
    homepage: null,
    size: 166,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Java",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 2,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 260716188,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjA3MTYxODg=",
    name: "dev-bytes-player",
    full_name: "nfragiskatos/dev-bytes-player",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/dev-bytes-player",
    description:
      "Example app to practice having apps work in an offline state.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/dev-bytes-player",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/dev-bytes-player/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/dev-bytes-player/deployments",
    created_at: "2020-05-02T15:26:34Z",
    updated_at: "2020-05-24T22:46:52Z",
    pushed_at: "2020-05-24T22:46:49Z",
    git_url: "git://github.com/nfragiskatos/dev-bytes-player.git",
    ssh_url: "git@github.com:nfragiskatos/dev-bytes-player.git",
    clone_url: "https://github.com/nfragiskatos/dev-bytes-player.git",
    svn_url: "https://github.com/nfragiskatos/dev-bytes-player",
    homepage: null,
    size: 2838,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 206195295,
    node_id: "MDEwOlJlcG9zaXRvcnkyMDYxOTUyOTU=",
    name: "Dice_Roller_Kotlin",
    full_name: "nfragiskatos/Dice_Roller_Kotlin",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/Dice_Roller_Kotlin",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Dice_Roller_Kotlin/deployments",
    created_at: "2019-09-04T00:23:21Z",
    updated_at: "2019-09-18T04:42:30Z",
    pushed_at: "2019-09-18T04:42:28Z",
    git_url: "git://github.com/nfragiskatos/Dice_Roller_Kotlin.git",
    ssh_url: "git@github.com:nfragiskatos/Dice_Roller_Kotlin.git",
    clone_url: "https://github.com/nfragiskatos/Dice_Roller_Kotlin.git",
    svn_url: "https://github.com/nfragiskatos/Dice_Roller_Kotlin",
    homepage: null,
    size: 137,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 129543847,
    node_id: "MDEwOlJlcG9zaXRvcnkxMjk1NDM4NDc=",
    name: "FilmJournal",
    full_name: "nfragiskatos/FilmJournal",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/FilmJournal",
    description: "Start",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/FilmJournal",
    forks_url: "https://api.github.com/repos/nfragiskatos/FilmJournal/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/FilmJournal/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/FilmJournal/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/FilmJournal/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/FilmJournal/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/FilmJournal/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/FilmJournal/deployments",
    created_at: "2018-04-14T18:30:19Z",
    updated_at: "2018-04-19T03:13:14Z",
    pushed_at: "2018-04-19T03:56:19Z",
    git_url: "git://github.com/nfragiskatos/FilmJournal.git",
    ssh_url: "git@github.com:nfragiskatos/FilmJournal.git",
    clone_url: "https://github.com/nfragiskatos/FilmJournal.git",
    svn_url: "https://github.com/nfragiskatos/FilmJournal",
    homepage: null,
    size: 173,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Java",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 493430535,
    node_id: "R_kgDOHWknBw",
    name: "FragGitHubBrowser",
    full_name: "nfragiskatos/FragGitHubBrowser",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/FragGitHubBrowser",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/FragGitHubBrowser/deployments",
    created_at: "2022-05-17T22:21:06Z",
    updated_at: "2022-05-17T22:21:14Z",
    pushed_at: "2022-05-17T22:21:09Z",
    git_url: "git://github.com/nfragiskatos/FragGitHubBrowser.git",
    ssh_url: "git@github.com:nfragiskatos/FragGitHubBrowser.git",
    clone_url: "https://github.com/nfragiskatos/FragGitHubBrowser.git",
    svn_url: "https://github.com/nfragiskatos/FragGitHubBrowser",
    homepage: null,
    size: 125,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 495999417,
    node_id: "R_kgDOHZBZuQ",
    name: "FragGoogleAuth",
    full_name: "nfragiskatos/FragGoogleAuth",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/FragGoogleAuth",
    description: "toy app",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/FragGoogleAuth",
    forks_url: "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth/deployments",
    created_at: "2022-05-24T21:55:40Z",
    updated_at: "2022-05-24T22:09:50Z",
    pushed_at: "2022-06-10T13:56:33Z",
    git_url: "git://github.com/nfragiskatos/FragGoogleAuth.git",
    ssh_url: "git@github.com:nfragiskatos/FragGoogleAuth.git",
    clone_url: "https://github.com/nfragiskatos/FragGoogleAuth.git",
    svn_url: "https://github.com/nfragiskatos/FragGoogleAuth",
    homepage: null,
    size: 160,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 497174591,
    node_id: "R_kgDOHaJIPw",
    name: "FragGoogleAuth-server",
    full_name: "nfragiskatos/FragGoogleAuth-server",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/FragGoogleAuth-server",
    description: "Backend for FragGoogleAuth project",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/FragGoogleAuth-server/deployments",
    created_at: "2022-05-28T00:36:27Z",
    updated_at: "2022-05-28T00:38:18Z",
    pushed_at: "2022-06-07T03:23:22Z",
    git_url: "git://github.com/nfragiskatos/FragGoogleAuth-server.git",
    ssh_url: "git@github.com:nfragiskatos/FragGoogleAuth-server.git",
    clone_url: "https://github.com/nfragiskatos/FragGoogleAuth-server.git",
    svn_url: "https://github.com/nfragiskatos/FragGoogleAuth-server",
    homepage: null,
    size: 88,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 274785138,
    node_id: "MDEwOlJlcG9zaXRvcnkyNzQ3ODUxMzg=",
    name: "FragGram",
    full_name: "nfragiskatos/FragGram",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/FragGram",
    description: "Toy app for practice. Instagram Clone",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/FragGram",
    forks_url: "https://api.github.com/repos/nfragiskatos/FragGram/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/FragGram/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/FragGram/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/FragGram/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/FragGram/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/FragGram/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/FragGram/deployments",
    created_at: "2020-06-24T22:55:57Z",
    updated_at: "2020-07-17T03:21:03Z",
    pushed_at: "2020-07-17T03:21:00Z",
    git_url: "git://github.com/nfragiskatos/FragGram.git",
    ssh_url: "git@github.com:nfragiskatos/FragGram.git",
    clone_url: "https://github.com/nfragiskatos/FragGram.git",
    svn_url: "https://github.com/nfragiskatos/FragGram",
    homepage: null,
    size: 1027,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 268110826,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjgxMTA4MjY=",
    name: "FragMessenger",
    full_name: "nfragiskatos/FragMessenger",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/FragMessenger",
    description: "Simple messenger application for practice.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/FragMessenger",
    forks_url: "https://api.github.com/repos/nfragiskatos/FragMessenger/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/FragMessenger/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/FragMessenger/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/FragMessenger/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/FragMessenger/deployments",
    created_at: "2020-05-30T15:48:19Z",
    updated_at: "2023-08-28T16:16:36Z",
    pushed_at: "2023-09-30T00:15:43Z",
    git_url: "git://github.com/nfragiskatos/FragMessenger.git",
    ssh_url: "git@github.com:nfragiskatos/FragMessenger.git",
    clone_url: "https://github.com/nfragiskatos/FragMessenger.git",
    svn_url: "https://github.com/nfragiskatos/FragMessenger",
    homepage: "",
    size: 2177,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 1,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 512562095,
    node_id: "R_kgDOHo0Trw",
    name: "FragWeather",
    full_name: "nfragiskatos/FragWeather",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/FragWeather",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/FragWeather",
    forks_url: "https://api.github.com/repos/nfragiskatos/FragWeather/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/FragWeather/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/FragWeather/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/FragWeather/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/FragWeather/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/FragWeather/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/FragWeather/deployments",
    created_at: "2022-07-10T23:32:27Z",
    updated_at: "2022-07-10T23:32:46Z",
    pushed_at: "2022-07-11T03:23:32Z",
    git_url: "git://github.com/nfragiskatos/FragWeather.git",
    ssh_url: "git@github.com:nfragiskatos/FragWeather.git",
    clone_url: "https://github.com/nfragiskatos/FragWeather.git",
    svn_url: "https://github.com/nfragiskatos/FragWeather",
    homepage: null,
    size: 119,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 256763754,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTY3NjM3NTQ=",
    name: "FruitPicker-DataBinding",
    full_name: "nfragiskatos/FruitPicker-DataBinding",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/FruitPicker-DataBinding",
    description: "Sample app used to practice/learn 2-way & 1-way data binding",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/FruitPicker-DataBinding/deployments",
    created_at: "2020-04-18T13:43:12Z",
    updated_at: "2020-04-18T15:15:40Z",
    pushed_at: "2020-04-18T15:15:37Z",
    git_url: "git://github.com/nfragiskatos/FruitPicker-DataBinding.git",
    ssh_url: "git@github.com:nfragiskatos/FruitPicker-DataBinding.git",
    clone_url: "https://github.com/nfragiskatos/FruitPicker-DataBinding.git",
    svn_url: "https://github.com/nfragiskatos/FruitPicker-DataBinding",
    homepage: null,
    size: 148,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 266652381,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjY2NTIzODE=",
    name: "gdg-finder",
    full_name: "nfragiskatos/gdg-finder",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/gdg-finder",
    description:
      "Practice help for getting experience with different design tools, styles and strategies. (Themes, styles, views, etc)",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/gdg-finder",
    forks_url: "https://api.github.com/repos/nfragiskatos/gdg-finder/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/gdg-finder/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/gdg-finder/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/gdg-finder/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/gdg-finder/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/gdg-finder/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/gdg-finder/deployments",
    created_at: "2020-05-25T01:00:03Z",
    updated_at: "2020-05-28T22:41:12Z",
    pushed_at: "2020-05-28T22:41:09Z",
    git_url: "git://github.com/nfragiskatos/gdg-finder.git",
    ssh_url: "git@github.com:nfragiskatos/gdg-finder.git",
    clone_url: "https://github.com/nfragiskatos/gdg-finder.git",
    svn_url: "https://github.com/nfragiskatos/gdg-finder",
    homepage: null,
    size: 9378,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "apache-2.0",
      name: "Apache License 2.0",
      spdx_id: "Apache-2.0",
      url: "https://api.github.com/licenses/apache-2.0",
      node_id: "MDc6TGljZW5zZTI=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 129538270,
    node_id: "MDEwOlJlcG9zaXRvcnkxMjk1MzgyNzA=",
    name: "hello-world",
    full_name: "nfragiskatos/hello-world",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/hello-world",
    description: "starting off",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/hello-world",
    forks_url: "https://api.github.com/repos/nfragiskatos/hello-world/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/hello-world/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/hello-world/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/hello-world/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/hello-world/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/hello-world/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/hello-world/deployments",
    created_at: "2018-04-14T17:16:14Z",
    updated_at: "2018-04-14T17:26:40Z",
    pushed_at: "2018-04-14T17:26:56Z",
    git_url: "git://github.com/nfragiskatos/hello-world.git",
    ssh_url: "git@github.com:nfragiskatos/hello-world.git",
    clone_url: "https://github.com/nfragiskatos/hello-world.git",
    svn_url: "https://github.com/nfragiskatos/hello-world",
    homepage: null,
    size: 1,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 259055728,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTkwNTU3Mjg=",
    name: "Mars-RealEstate-with-Retrofit",
    full_name: "nfragiskatos/Mars-RealEstate-with-Retrofit",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/Mars-RealEstate-with-Retrofit",
    description:
      "Practice app to practice fetching data from a network backend using the Retrofit library. Also uses MVVM architecture with Data Binding, and Grid Style RecyclerView",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Mars-RealEstate-with-Retrofit/deployments",
    created_at: "2020-04-26T14:49:29Z",
    updated_at: "2020-05-01T03:06:05Z",
    pushed_at: "2020-05-01T03:06:02Z",
    git_url: "git://github.com/nfragiskatos/Mars-RealEstate-with-Retrofit.git",
    ssh_url: "git@github.com:nfragiskatos/Mars-RealEstate-with-Retrofit.git",
    clone_url:
      "https://github.com/nfragiskatos/Mars-RealEstate-with-Retrofit.git",
    svn_url: "https://github.com/nfragiskatos/Mars-RealEstate-with-Retrofit",
    homepage: null,
    size: 4084,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 463694503,
    node_id: "R_kgDOG6Nqpw",
    name: "Mealz_App",
    full_name: "nfragiskatos/Mealz_App",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/Mealz_App",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Mealz_App",
    forks_url: "https://api.github.com/repos/nfragiskatos/Mealz_App/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/Mealz_App/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/Mealz_App/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/Mealz_App/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/Mealz_App/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/Mealz_App/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Mealz_App/deployments",
    created_at: "2022-02-25T22:40:11Z",
    updated_at: "2022-02-25T22:40:22Z",
    pushed_at: "2022-02-28T04:07:13Z",
    git_url: "git://github.com/nfragiskatos/Mealz_App.git",
    ssh_url: "git@github.com:nfragiskatos/Mealz_App.git",
    clone_url: "https://github.com/nfragiskatos/Mealz_App.git",
    svn_url: "https://github.com/nfragiskatos/Mealz_App",
    homepage: null,
    size: 116,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 149842804,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDk4NDI4MDQ=",
    name: "movie_search_app",
    full_name: "nfragiskatos/movie_search_app",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/movie_search_app",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/movie_search_app",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/movie_search_app/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/movie_search_app/deployments",
    created_at: "2018-09-22T03:44:44Z",
    updated_at: "2018-09-22T04:40:01Z",
    pushed_at: "2018-09-22T04:40:00Z",
    git_url: "git://github.com/nfragiskatos/movie_search_app.git",
    ssh_url: "git@github.com:nfragiskatos/movie_search_app.git",
    clone_url: "https://github.com/nfragiskatos/movie_search_app.git",
    svn_url: "https://github.com/nfragiskatos/movie_search_app",
    homepage: null,
    size: 2,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 360316756,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjAzMTY3NTY=",
    name: "my-react-app_1",
    full_name: "nfragiskatos/my-react-app_1",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/my-react-app_1",
    description: "Toy App for learning React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/my-react-app_1",
    forks_url: "https://api.github.com/repos/nfragiskatos/my-react-app_1/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/my-react-app_1/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/my-react-app_1/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/my-react-app_1/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/my-react-app_1/deployments",
    created_at: "2021-04-21T21:57:46Z",
    updated_at: "2021-04-21T21:57:48Z",
    pushed_at: "2021-04-22T04:05:11Z",
    git_url: "git://github.com/nfragiskatos/my-react-app_1.git",
    ssh_url: "git@github.com:nfragiskatos/my-react-app_1.git",
    clone_url: "https://github.com/nfragiskatos/my-react-app_1.git",
    svn_url: "https://github.com/nfragiskatos/my-react-app_1",
    homepage: null,
    size: 199,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 504871823,
    node_id: "R_kgDOHhe7jw",
    name: "MyInstaClone",
    full_name: "nfragiskatos/MyInstaClone",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/MyInstaClone",
    description:
      "Limited clone of the Instagram app using Android Jetpack Compose and Firebase",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/MyInstaClone",
    forks_url: "https://api.github.com/repos/nfragiskatos/MyInstaClone/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/MyInstaClone/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/MyInstaClone/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/MyInstaClone/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/MyInstaClone/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/MyInstaClone/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/MyInstaClone/deployments",
    created_at: "2022-06-18T14:53:12Z",
    updated_at: "2023-04-14T05:51:43Z",
    pushed_at: "2022-06-29T03:44:17Z",
    git_url: "git://github.com/nfragiskatos/MyInstaClone.git",
    ssh_url: "git@github.com:nfragiskatos/MyInstaClone.git",
    clone_url: "https://github.com/nfragiskatos/MyInstaClone.git",
    svn_url: "https://github.com/nfragiskatos/MyInstaClone",
    homepage: "",
    size: 945,
    stargazers_count: 4,
    watchers_count: 4,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "android",
      "android-app-development",
      "dagger-hilt",
      "dependency-injection",
      "firebase",
      "firebase-auth",
      "firebase-database",
      "jetpack-compose",
      "kotlin",
      "kotlin-android",
      "mvvm-android",
      "mvvm-architecture",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 1,
    watchers: 4,
    default_branch: "main",
  },
  {
    id: 484591193,
    node_id: "R_kgDOHOJGWQ",
    name: "mykotlinspringrestapi",
    full_name: "nfragiskatos/mykotlinspringrestapi",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/mykotlinspringrestapi",
    description:
      "Toy app to learn about creating a REST API backend with Kotlin and Spring",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/mykotlinspringrestapi/deployments",
    created_at: "2022-04-22T22:45:28Z",
    updated_at: "2022-04-22T22:45:35Z",
    pushed_at: "2022-04-23T12:57:15Z",
    git_url: "git://github.com/nfragiskatos/mykotlinspringrestapi.git",
    ssh_url: "git@github.com:nfragiskatos/mykotlinspringrestapi.git",
    clone_url: "https://github.com/nfragiskatos/mykotlinspringrestapi.git",
    svn_url: "https://github.com/nfragiskatos/mykotlinspringrestapi",
    homepage: null,
    size: 73,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 415367645,
    node_id: "R_kgDOGMIB3Q",
    name: "News_API_Client",
    full_name: "nfragiskatos/News_API_Client",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/News_API_Client",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/News_API_Client",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/News_API_Client/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/News_API_Client/deployments",
    created_at: "2021-10-09T16:50:13Z",
    updated_at: "2021-10-20T04:27:40Z",
    pushed_at: "2021-10-20T04:27:37Z",
    git_url: "git://github.com/nfragiskatos/News_API_Client.git",
    ssh_url: "git@github.com:nfragiskatos/News_API_Client.git",
    clone_url: "https://github.com/nfragiskatos/News_API_Client.git",
    svn_url: "https://github.com/nfragiskatos/News_API_Client",
    homepage: null,
    size: 193,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 487666674,
    node_id: "R_kgDOHREz8g",
    name: "NoteTaker",
    full_name: "nfragiskatos/NoteTaker",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/NoteTaker",
    description: "Simple note taking app for practicing Android development.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/NoteTaker",
    forks_url: "https://api.github.com/repos/nfragiskatos/NoteTaker/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/NoteTaker/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/NoteTaker/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/NoteTaker/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/NoteTaker/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/NoteTaker/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/NoteTaker/deployments",
    created_at: "2022-05-01T23:39:41Z",
    updated_at: "2024-01-14T11:23:15Z",
    pushed_at: "2022-06-27T03:07:10Z",
    git_url: "git://github.com/nfragiskatos/NoteTaker.git",
    ssh_url: "git@github.com:nfragiskatos/NoteTaker.git",
    clone_url: "https://github.com/nfragiskatos/NoteTaker.git",
    svn_url: "https://github.com/nfragiskatos/NoteTaker",
    homepage: "",
    size: 157,
    stargazers_count: 1,
    watchers_count: 1,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "android",
      "android-application",
      "android-development",
      "clean-architecture",
      "clean-code",
      "compose-android",
      "composer-library",
      "coroutines",
      "coroutines-android",
      "coroutines-flow",
      "kotlin",
      "kotlin-android",
      "mvvm",
      "mvvm-android",
      "mvvm-architecture",
      "room",
      "room-database",
      "roomdatabase",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "master",
  },
  {
    id: 334688225,
    node_id: "MDEwOlJlcG9zaXRvcnkzMzQ2ODgyMjU=",
    name: "notifications-toy-app",
    full_name: "nfragiskatos/notifications-toy-app",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/notifications-toy-app",
    description: "Practice using notifications",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/notifications-toy-app",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/notifications-toy-app/deployments",
    created_at: "2021-01-31T15:28:33Z",
    updated_at: "2021-01-31T15:28:49Z",
    pushed_at: "2021-01-31T15:28:46Z",
    git_url: "git://github.com/nfragiskatos/notifications-toy-app.git",
    ssh_url: "git@github.com:nfragiskatos/notifications-toy-app.git",
    clone_url: "https://github.com/nfragiskatos/notifications-toy-app.git",
    svn_url: "https://github.com/nfragiskatos/notifications-toy-app",
    homepage: null,
    size: 245,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 716720651,
    node_id: "R_kgDOKrhKCw",
    name: "ObjectRelationshipsInRoom",
    full_name: "nfragiskatos/ObjectRelationshipsInRoom",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/ObjectRelationshipsInRoom",
    description:
      "Sample project on how to create object relationships in Room for Android",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/ObjectRelationshipsInRoom/deployments",
    created_at: "2023-11-09T18:21:20Z",
    updated_at: "2023-11-16T14:11:52Z",
    pushed_at: "2023-11-16T14:06:51Z",
    git_url: "git://github.com/nfragiskatos/ObjectRelationshipsInRoom.git",
    ssh_url: "git@github.com:nfragiskatos/ObjectRelationshipsInRoom.git",
    clone_url: "https://github.com/nfragiskatos/ObjectRelationshipsInRoom.git",
    svn_url: "https://github.com/nfragiskatos/ObjectRelationshipsInRoom",
    homepage:
      "https://blog.nicholasfragiskatos.dev/object-relationships-in-room-orm-library-for-android",
    size: 146,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "android",
      "android-development",
      "android-framework",
      "android-room",
      "room-database",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 676740979,
    node_id: "R_kgDOKFY_cw",
    name: "PhotoGallery",
    full_name: "nfragiskatos/PhotoGallery",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/PhotoGallery",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/PhotoGallery",
    forks_url: "https://api.github.com/repos/nfragiskatos/PhotoGallery/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/PhotoGallery/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/PhotoGallery/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/PhotoGallery/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/PhotoGallery/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/PhotoGallery/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/PhotoGallery/deployments",
    created_at: "2023-08-09T22:49:49Z",
    updated_at: "2023-08-24T15:52:21Z",
    pushed_at: "2023-11-30T04:43:15Z",
    git_url: "git://github.com/nfragiskatos/PhotoGallery.git",
    ssh_url: "git@github.com:nfragiskatos/PhotoGallery.git",
    clone_url: "https://github.com/nfragiskatos/PhotoGallery.git",
    svn_url: "https://github.com/nfragiskatos/PhotoGallery",
    homepage: null,
    size: 145,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 256835202,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTY4MzUyMDI=",
    name: "QuoteApp-DI-Kodein_mvvm",
    full_name: "nfragiskatos/QuoteApp-DI-Kodein_mvvm",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/QuoteApp-DI-Kodein_mvvm",
    description:
      "Simply app used to practice Dependency Injection w/ Kodein and also MVVM",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-DI-Kodein_mvvm/deployments",
    created_at: "2020-04-18T19:24:01Z",
    updated_at: "2020-04-18T22:43:17Z",
    pushed_at: "2020-04-18T22:43:14Z",
    git_url: "git://github.com/nfragiskatos/QuoteApp-DI-Kodein_mvvm.git",
    ssh_url: "git@github.com:nfragiskatos/QuoteApp-DI-Kodein_mvvm.git",
    clone_url: "https://github.com/nfragiskatos/QuoteApp-DI-Kodein_mvvm.git",
    svn_url: "https://github.com/nfragiskatos/QuoteApp-DI-Kodein_mvvm",
    homepage: null,
    size: 153,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 256575623,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTY1NzU2MjM=",
    name: "QuoteApp-MvvmBasics",
    full_name: "nfragiskatos/QuoteApp-MvvmBasics",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/QuoteApp-MvvmBasics",
    description: "Simple app used to practice/learn MVVM",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/QuoteApp-MvvmBasics/deployments",
    created_at: "2020-04-17T18:05:24Z",
    updated_at: "2020-04-17T22:33:18Z",
    pushed_at: "2020-04-17T22:33:15Z",
    git_url: "git://github.com/nfragiskatos/QuoteApp-MvvmBasics.git",
    ssh_url: "git@github.com:nfragiskatos/QuoteApp-MvvmBasics.git",
    clone_url: "https://github.com/nfragiskatos/QuoteApp-MvvmBasics.git",
    svn_url: "https://github.com/nfragiskatos/QuoteApp-MvvmBasics",
    homepage: null,
    size: 142,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 360971648,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjA5NzE2NDg=",
    name: "React-Accordion",
    full_name: "nfragiskatos/React-Accordion",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Accordion",
    description: "Toy app to practice React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Accordion",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Accordion/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Accordion/deployments",
    created_at: "2021-04-23T18:21:43Z",
    updated_at: "2021-04-23T19:30:21Z",
    pushed_at: "2021-04-23T19:30:19Z",
    git_url: "git://github.com/nfragiskatos/React-Accordion.git",
    ssh_url: "git@github.com:nfragiskatos/React-Accordion.git",
    clone_url: "https://github.com/nfragiskatos/React-Accordion.git",
    svn_url: "https://github.com/nfragiskatos/React-Accordion",
    homepage: null,
    size: 938,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 360663053,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjA2NjMwNTM=",
    name: "React-Birthday_Reminder",
    full_name: "nfragiskatos/React-Birthday_Reminder",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Birthday_Reminder",
    description: "Toy project to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Birthday_Reminder/deployments",
    created_at: "2021-04-22T19:42:01Z",
    updated_at: "2021-04-22T22:31:07Z",
    pushed_at: "2021-04-22T22:31:05Z",
    git_url: "git://github.com/nfragiskatos/React-Birthday_Reminder.git",
    ssh_url: "git@github.com:nfragiskatos/React-Birthday_Reminder.git",
    clone_url: "https://github.com/nfragiskatos/React-Birthday_Reminder.git",
    svn_url: "https://github.com/nfragiskatos/React-Birthday_Reminder",
    homepage: null,
    size: 378,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 362271077,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjIyNzEwNzc=",
    name: "React-Cart",
    full_name: "nfragiskatos/React-Cart",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Cart",
    description: "Toy app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Cart",
    forks_url: "https://api.github.com/repos/nfragiskatos/React-Cart/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/React-Cart/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/React-Cart/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/React-Cart/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Cart/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/React-Cart/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Cart/deployments",
    created_at: "2021-04-27T22:43:02Z",
    updated_at: "2021-04-28T03:27:50Z",
    pushed_at: "2021-04-28T03:27:48Z",
    git_url: "git://github.com/nfragiskatos/React-Cart.git",
    ssh_url: "git@github.com:nfragiskatos/React-Cart.git",
    clone_url: "https://github.com/nfragiskatos/React-Cart.git",
    svn_url: "https://github.com/nfragiskatos/React-Cart",
    homepage: null,
    size: 178,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 363426150,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjM0MjYxNTA=",
    name: "React-Cocktails",
    full_name: "nfragiskatos/React-Cocktails",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Cocktails",
    description:
      "Simple app to search a cocktail database and display results plus individual details.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Cocktails",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Cocktails/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Cocktails/deployments",
    created_at: "2021-05-01T14:11:38Z",
    updated_at: "2022-05-03T17:18:33Z",
    pushed_at: "2021-05-01T16:04:02Z",
    git_url: "git://github.com/nfragiskatos/React-Cocktails.git",
    ssh_url: "git@github.com:nfragiskatos/React-Cocktails.git",
    clone_url: "https://github.com/nfragiskatos/React-Cocktails.git",
    svn_url: "https://github.com/nfragiskatos/React-Cocktails",
    homepage: "https://nfragiskatos.github.io/React-Cocktails/",
    size: 562,
    stargazers_count: 1,
    watchers_count: 1,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ["css", "html", "javascript", "react", "react-router"],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "main",
  },
  {
    id: 361336741,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjEzMzY3NDE=",
    name: "React-Color_Generator",
    full_name: "nfragiskatos/React-Color_Generator",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Color_Generator",
    description: "Toy app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Color_Generator",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Color_Generator/deployments",
    created_at: "2021-04-25T05:12:32Z",
    updated_at: "2021-04-25T05:14:41Z",
    pushed_at: "2021-04-25T05:14:39Z",
    git_url: "git://github.com/nfragiskatos/React-Color_Generator.git",
    ssh_url: "git@github.com:nfragiskatos/React-Color_Generator.git",
    clone_url: "https://github.com/nfragiskatos/React-Color_Generator.git",
    svn_url: "https://github.com/nfragiskatos/React-Color_Generator",
    homepage: null,
    size: 174,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 382721169,
    node_id: "MDEwOlJlcG9zaXRvcnkzODI3MjExNjk=",
    name: "React-Comfy_Sloth",
    full_name: "nfragiskatos/React-Comfy_Sloth",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Comfy_Sloth",
    description:
      "React app shopping page with shopping cart. Also leverages Auth0 for signup/login/logout functionality.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Comfy_Sloth/deployments",
    created_at: "2021-07-03T22:41:31Z",
    updated_at: "2021-07-05T23:11:43Z",
    pushed_at: "2021-07-05T23:11:41Z",
    git_url: "git://github.com/nfragiskatos/React-Comfy_Sloth.git",
    ssh_url: "git@github.com:nfragiskatos/React-Comfy_Sloth.git",
    clone_url: "https://github.com/nfragiskatos/React-Comfy_Sloth.git",
    svn_url: "https://github.com/nfragiskatos/React-Comfy_Sloth",
    homepage: "https://nfragiskatos.github.io/React-Comfy_Sloth/",
    size: 3930,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "api",
      "auth0",
      "authentication",
      "css",
      "html",
      "javascript",
      "react",
      "react-router",
      "react-router-dom",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 365622002,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjU2MjIwMDI=",
    name: "React-Dark_Mode",
    full_name: "nfragiskatos/React-Dark_Mode",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Dark_Mode",
    description: "Simple app to display theme (light vs dark) toggling",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Dark_Mode",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Dark_Mode/deployments",
    created_at: "2021-05-08T22:23:43Z",
    updated_at: "2021-05-08T22:37:00Z",
    pushed_at: "2021-05-08T22:36:59Z",
    git_url: "git://github.com/nfragiskatos/React-Dark_Mode.git",
    ssh_url: "git@github.com:nfragiskatos/React-Dark_Mode.git",
    clone_url: "https://github.com/nfragiskatos/React-Dark_Mode.git",
    svn_url: "https://github.com/nfragiskatos/React-Dark_Mode",
    homepage: "https://nfragiskatos.github.io/React-Dark_Mode/",
    size: 404,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ["css", "html", "javascript", "react"],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 367947609,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjc5NDc2MDk=",
    name: "React-GitHub_Users",
    full_name: "nfragiskatos/React-GitHub_Users",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-GitHub_Users",
    description:
      "React app to display GitHub user information with a dashboard. Also leverages Auth0 for signup/login/logout functionality.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-GitHub_Users",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-GitHub_Users/deployments",
    created_at: "2021-05-16T17:40:19Z",
    updated_at: "2023-12-22T04:45:56Z",
    pushed_at: "2023-12-17T22:08:08Z",
    git_url: "git://github.com/nfragiskatos/React-GitHub_Users.git",
    ssh_url: "git@github.com:nfragiskatos/React-GitHub_Users.git",
    clone_url: "https://github.com/nfragiskatos/React-GitHub_Users.git",
    svn_url: "https://github.com/nfragiskatos/React-GitHub_Users",
    homepage: "https://nfragiskatos.github.io/React-GitHub_Users/",
    size: 2318,
    stargazers_count: 1,
    watchers_count: 1,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "api",
      "auth0",
      "authentication",
      "css",
      "html",
      "javascript",
      "react",
      "react-router",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "main",
  },
  {
    id: 361473991,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjE0NzM5OTE=",
    name: "React-Grocery_Bud",
    full_name: "nfragiskatos/React-Grocery_Bud",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Grocery_Bud",
    description: "To app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Grocery_Bud/deployments",
    created_at: "2021-04-25T16:03:09Z",
    updated_at: "2021-04-25T16:14:12Z",
    pushed_at: "2021-04-25T16:14:10Z",
    git_url: "git://github.com/nfragiskatos/React-Grocery_Bud.git",
    ssh_url: "git@github.com:nfragiskatos/React-Grocery_Bud.git",
    clone_url: "https://github.com/nfragiskatos/React-Grocery_Bud.git",
    svn_url: "https://github.com/nfragiskatos/React-Grocery_Bud",
    homepage: null,
    size: 179,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 367710220,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjc3MTAyMjA=",
    name: "React-Hacker_News",
    full_name: "nfragiskatos/React-Hacker_News",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Hacker_News",
    description:
      "App to retrieve and display news stories using pagination from Hacker News API",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Hacker_News",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Hacker_News/deployments",
    created_at: "2021-05-15T19:04:15Z",
    updated_at: "2021-05-15T23:01:43Z",
    pushed_at: "2021-05-15T23:01:41Z",
    git_url: "git://github.com/nfragiskatos/React-Hacker_News.git",
    ssh_url: "git@github.com:nfragiskatos/React-Hacker_News.git",
    clone_url: "https://github.com/nfragiskatos/React-Hacker_News.git",
    svn_url: "https://github.com/nfragiskatos/React-Hacker_News",
    homepage: "https://nfragiskatos.github.io/React-Hacker_News/",
    size: 340,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "api",
      "css",
      "global-context",
      "html",
      "javascript",
      "pagination",
      "reac",
      "react-hooks",
      "reducer",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 361300947,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjEzMDA5NDc=",
    name: "React-LoremIpsum",
    full_name: "nfragiskatos/React-LoremIpsum",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-LoremIpsum",
    description: "To app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-LoremIpsum",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-LoremIpsum/deployments",
    created_at: "2021-04-25T01:11:15Z",
    updated_at: "2021-04-25T01:14:27Z",
    pushed_at: "2021-04-25T01:14:25Z",
    git_url: "git://github.com/nfragiskatos/React-LoremIpsum.git",
    ssh_url: "git@github.com:nfragiskatos/React-LoremIpsum.git",
    clone_url: "https://github.com/nfragiskatos/React-LoremIpsum.git",
    svn_url: "https://github.com/nfragiskatos/React-LoremIpsum",
    homepage: null,
    size: 173,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 364771604,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjQ3NzE2MDQ=",
    name: "React-Markdown_Preview",
    full_name: "nfragiskatos/React-Markdown_Preview",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Markdown_Preview",
    description:
      "Simple app for markdown editing. Relies primarily on react-markdown",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Markdown_Preview/deployments",
    created_at: "2021-05-06T03:18:49Z",
    updated_at: "2021-05-06T04:15:10Z",
    pushed_at: "2021-05-06T04:15:08Z",
    git_url: "git://github.com/nfragiskatos/React-Markdown_Preview.git",
    ssh_url: "git@github.com:nfragiskatos/React-Markdown_Preview.git",
    clone_url: "https://github.com/nfragiskatos/React-Markdown_Preview.git",
    svn_url: "https://github.com/nfragiskatos/React-Markdown_Preview",
    homepage: "https://nfragiskatos.github.io/React-Markdown_Preview/",
    size: 1279,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ["css", "html", "javascript", "react", "react-markdown"],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 361022346,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjEwMjIzNDY=",
    name: "React-Menu",
    full_name: "nfragiskatos/React-Menu",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Menu",
    description: "Toy app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Menu",
    forks_url: "https://api.github.com/repos/nfragiskatos/React-Menu/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/React-Menu/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/React-Menu/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/React-Menu/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Menu/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/React-Menu/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Menu/deployments",
    created_at: "2021-04-23T22:45:17Z",
    updated_at: "2021-04-24T04:34:57Z",
    pushed_at: "2021-04-24T04:34:55Z",
    git_url: "git://github.com/nfragiskatos/React-Menu.git",
    ssh_url: "git@github.com:nfragiskatos/React-Menu.git",
    clone_url: "https://github.com/nfragiskatos/React-Menu.git",
    svn_url: "https://github.com/nfragiskatos/React-Menu",
    homepage: null,
    size: 848,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 367673820,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjc2NzM4MjA=",
    name: "React-MovieDB",
    full_name: "nfragiskatos/React-MovieDB",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-MovieDB",
    description: "Simple app using OMDb API to search for movies.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-MovieDB",
    forks_url: "https://api.github.com/repos/nfragiskatos/React-MovieDB/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/React-MovieDB/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/React-MovieDB/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-MovieDB/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-MovieDB/deployments",
    created_at: "2021-05-15T16:00:44Z",
    updated_at: "2021-05-15T16:26:25Z",
    pushed_at: "2021-05-15T16:26:23Z",
    git_url: "git://github.com/nfragiskatos/React-MovieDB.git",
    ssh_url: "git@github.com:nfragiskatos/React-MovieDB.git",
    clone_url: "https://github.com/nfragiskatos/React-MovieDB.git",
    svn_url: "https://github.com/nfragiskatos/React-MovieDB",
    homepage: "https://nfragiskatos.github.io/React-MovieDB/",
    size: 390,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ["api", "css", "html", "javascript", "react", "react-router"],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 361510289,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjE1MTAyODk=",
    name: "React-Navbar",
    full_name: "nfragiskatos/React-Navbar",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Navbar",
    description: "Toy app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Navbar",
    forks_url: "https://api.github.com/repos/nfragiskatos/React-Navbar/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/React-Navbar/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/React-Navbar/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/React-Navbar/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Navbar/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/React-Navbar/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Navbar/deployments",
    created_at: "2021-04-25T18:43:08Z",
    updated_at: "2021-04-25T18:52:49Z",
    pushed_at: "2021-04-25T18:52:47Z",
    git_url: "git://github.com/nfragiskatos/React-Navbar.git",
    ssh_url: "git@github.com:nfragiskatos/React-Navbar.git",
    clone_url: "https://github.com/nfragiskatos/React-Navbar.git",
    svn_url: "https://github.com/nfragiskatos/React-Navbar",
    homepage: null,
    size: 177,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 365077026,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjUwNzcwMjY=",
    name: "React-Pagination",
    full_name: "nfragiskatos/React-Pagination",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Pagination",
    description:
      "App to pull data large amount of user data from the GitHub API and show it using client-side pagination.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Pagination",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Pagination/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Pagination/deployments",
    created_at: "2021-05-07T01:04:44Z",
    updated_at: "2021-05-07T04:55:03Z",
    pushed_at: "2021-05-07T04:55:01Z",
    git_url: "git://github.com/nfragiskatos/React-Pagination.git",
    ssh_url: "git@github.com:nfragiskatos/React-Pagination.git",
    clone_url: "https://github.com/nfragiskatos/React-Pagination.git",
    svn_url: "https://github.com/nfragiskatos/React-Pagination",
    homepage: "https://nfragiskatos.github.io/React-Pagination/",
    size: 335,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ["api", "css", "html", "javascript", "react"],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 367940830,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjc5NDA4MzA=",
    name: "React-Quiz",
    full_name: "nfragiskatos/React-Quiz",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Quiz",
    description: "Quiz app using OpenTDB API",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Quiz",
    forks_url: "https://api.github.com/repos/nfragiskatos/React-Quiz/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/React-Quiz/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/React-Quiz/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/React-Quiz/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Quiz/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/React-Quiz/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Quiz/deployments",
    created_at: "2021-05-16T17:07:21Z",
    updated_at: "2021-05-16T17:14:11Z",
    pushed_at: "2021-05-16T17:14:08Z",
    git_url: "git://github.com/nfragiskatos/React-Quiz.git",
    ssh_url: "git@github.com:nfragiskatos/React-Quiz.git",
    clone_url: "https://github.com/nfragiskatos/React-Quiz.git",
    svn_url: "https://github.com/nfragiskatos/React-Quiz",
    homepage: "https://nfragiskatos.github.io/React-Quiz/",
    size: 369,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ["axios", "css", "html", "javascript", "react", "usecontext-hook"],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 364783192,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjQ3ODMxOTI=",
    name: "React-Random_User",
    full_name: "nfragiskatos/React-Random_User",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Random_User",
    description:
      "App to generate random users using the https://randomuser.me/ API",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Random_User",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Random_User/deployments",
    created_at: "2021-05-06T04:22:19Z",
    updated_at: "2021-05-07T00:58:19Z",
    pushed_at: "2021-05-07T00:58:17Z",
    git_url: "git://github.com/nfragiskatos/React-Random_User.git",
    ssh_url: "git@github.com:nfragiskatos/React-Random_User.git",
    clone_url: "https://github.com/nfragiskatos/React-Random_User.git",
    svn_url: "https://github.com/nfragiskatos/React-Random_User",
    homepage: "https://nfragiskatos.github.io/React-Random_User/",
    size: 737,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ["css", "html", "javascript", "react"],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 360744967,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjA3NDQ5Njc=",
    name: "React-Reviews",
    full_name: "nfragiskatos/React-Reviews",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Reviews",
    description: "Toy app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Reviews",
    forks_url: "https://api.github.com/repos/nfragiskatos/React-Reviews/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/React-Reviews/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/React-Reviews/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Reviews/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Reviews/deployments",
    created_at: "2021-04-23T02:51:44Z",
    updated_at: "2021-04-23T19:28:08Z",
    pushed_at: "2021-04-23T03:39:27Z",
    git_url: "git://github.com/nfragiskatos/React-Reviews.git",
    ssh_url: "git@github.com:nfragiskatos/React-Reviews.git",
    clone_url: "https://github.com/nfragiskatos/React-Reviews.git",
    svn_url: "https://github.com/nfragiskatos/React-Reviews",
    homepage: null,
    size: 323,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 361593373,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjE1OTMzNzM=",
    name: "React-Sidebar_Modal",
    full_name: "nfragiskatos/React-Sidebar_Modal",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Sidebar_Modal",
    description: "Toy app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Sidebar_Modal/deployments",
    created_at: "2021-04-26T02:28:12Z",
    updated_at: "2021-04-26T02:31:40Z",
    pushed_at: "2021-04-26T02:31:38Z",
    git_url: "git://github.com/nfragiskatos/React-Sidebar_Modal.git",
    ssh_url: "git@github.com:nfragiskatos/React-Sidebar_Modal.git",
    clone_url: "https://github.com/nfragiskatos/React-Sidebar_Modal.git",
    svn_url: "https://github.com/nfragiskatos/React-Sidebar_Modal",
    homepage: null,
    size: 178,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 361198040,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjExOTgwNDA=",
    name: "React-Slider",
    full_name: "nfragiskatos/React-Slider",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Slider",
    description: "Toy app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Slider",
    forks_url: "https://api.github.com/repos/nfragiskatos/React-Slider/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/React-Slider/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/React-Slider/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/React-Slider/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Slider/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/React-Slider/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Slider/deployments",
    created_at: "2021-04-24T15:29:48Z",
    updated_at: "2021-04-24T23:08:01Z",
    pushed_at: "2021-04-24T23:07:59Z",
    git_url: "git://github.com/nfragiskatos/React-Slider.git",
    ssh_url: "git@github.com:nfragiskatos/React-Slider.git",
    clone_url: "https://github.com/nfragiskatos/React-Slider.git",
    svn_url: "https://github.com/nfragiskatos/React-Slider",
    homepage: null,
    size: 175,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 365368341,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjUzNjgzNDE=",
    name: "React-Stock_Photos",
    full_name: "nfragiskatos/React-Stock_Photos",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Stock_Photos",
    description:
      "App to use Unsplash API to search and scroll through photos with infinite scroll feature.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Stock_Photos",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Stock_Photos/deployments",
    created_at: "2021-05-07T22:37:34Z",
    updated_at: "2021-05-08T18:35:08Z",
    pushed_at: "2021-05-08T18:35:06Z",
    git_url: "git://github.com/nfragiskatos/React-Stock_Photos.git",
    ssh_url: "git@github.com:nfragiskatos/React-Stock_Photos.git",
    clone_url: "https://github.com/nfragiskatos/React-Stock_Photos.git",
    svn_url: "https://github.com/nfragiskatos/React-Stock_Photos",
    homepage: "https://nfragiskatos.github.io/React-Stock_Photos/",
    size: 739,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "api",
      "css",
      "html",
      "javascript",
      "react",
      "useeffect",
      "usestate",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 361595303,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjE1OTUzMDM=",
    name: "React-Stripe_Submenues",
    full_name: "nfragiskatos/React-Stripe_Submenues",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Stripe_Submenues",
    description: "To app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Stripe_Submenues/deployments",
    created_at: "2021-04-26T02:37:39Z",
    updated_at: "2021-04-26T22:05:45Z",
    pushed_at: "2021-04-26T22:05:43Z",
    git_url: "git://github.com/nfragiskatos/React-Stripe_Submenues.git",
    ssh_url: "git@github.com:nfragiskatos/React-Stripe_Submenues.git",
    clone_url: "https://github.com/nfragiskatos/React-Stripe_Submenues.git",
    svn_url: "https://github.com/nfragiskatos/React-Stripe_Submenues",
    homepage: null,
    size: 583,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 361166733,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjExNjY3MzM=",
    name: "React-Tabs",
    full_name: "nfragiskatos/React-Tabs",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Tabs",
    description: "Toy app to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Tabs",
    forks_url: "https://api.github.com/repos/nfragiskatos/React-Tabs/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/React-Tabs/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/React-Tabs/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/React-Tabs/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Tabs/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/React-Tabs/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Tabs/deployments",
    created_at: "2021-04-24T13:18:32Z",
    updated_at: "2021-04-24T14:31:51Z",
    pushed_at: "2021-04-24T14:31:49Z",
    git_url: "git://github.com/nfragiskatos/React-Tabs.git",
    ssh_url: "git@github.com:nfragiskatos/React-Tabs.git",
    clone_url: "https://github.com/nfragiskatos/React-Tabs.git",
    svn_url: "https://github.com/nfragiskatos/React-Tabs",
    homepage: null,
    size: 172,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 360699486,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjA2OTk0ODY=",
    name: "React-Tours",
    full_name: "nfragiskatos/React-Tours",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/React-Tours",
    description: "Toy project to learn React",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/React-Tours",
    forks_url: "https://api.github.com/repos/nfragiskatos/React-Tours/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/React-Tours/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/React-Tours/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/React-Tours/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/React-Tours/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/React-Tours/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/React-Tours/deployments",
    created_at: "2021-04-22T22:39:20Z",
    updated_at: "2021-04-23T00:22:13Z",
    pushed_at: "2021-04-23T00:22:10Z",
    git_url: "git://github.com/nfragiskatos/React-Tours.git",
    ssh_url: "git@github.com:nfragiskatos/React-Tours.git",
    clone_url: "https://github.com/nfragiskatos/React-Tours.git",
    svn_url: "https://github.com/nfragiskatos/React-Tours",
    homepage: null,
    size: 381,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 417857157,
    node_id: "R_kgDOGOf-hQ",
    name: "react-website-with-styled-components",
    full_name: "nfragiskatos/react-website-with-styled-components",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url:
      "https://github.com/nfragiskatos/react-website-with-styled-components",
    description:
      "React app to mainly to learn/practice using Styled Components as well as other general web development skills",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/react-website-with-styled-components/deployments",
    created_at: "2021-10-16T14:45:56Z",
    updated_at: "2021-10-17T18:07:58Z",
    pushed_at: "2021-10-17T18:04:23Z",
    git_url:
      "git://github.com/nfragiskatos/react-website-with-styled-components.git",
    ssh_url:
      "git@github.com:nfragiskatos/react-website-with-styled-components.git",
    clone_url:
      "https://github.com/nfragiskatos/react-website-with-styled-components.git",
    svn_url:
      "https://github.com/nfragiskatos/react-website-with-styled-components",
    homepage:
      "https://nfragiskatos.github.io/react-website-with-styled-components/",
    size: 16048,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "css",
      "css-grid",
      "flexbox",
      "html",
      "javascript",
      "react",
      "react-router",
      "styled-components",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 420471974,
    node_id: "R_kgDOGQ_kpg",
    name: "recipe_mvvm_compose",
    full_name: "nfragiskatos/recipe_mvvm_compose",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/recipe_mvvm_compose",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/recipe_mvvm_compose/deployments",
    created_at: "2021-10-23T16:59:05Z",
    updated_at: "2021-11-09T00:40:42Z",
    pushed_at: "2021-11-09T00:40:39Z",
    git_url: "git://github.com/nfragiskatos/recipe_mvvm_compose.git",
    ssh_url: "git@github.com:nfragiskatos/recipe_mvvm_compose.git",
    clone_url: "https://github.com/nfragiskatos/recipe_mvvm_compose.git",
    svn_url: "https://github.com/nfragiskatos/recipe_mvvm_compose",
    homepage: null,
    size: 431,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 149950416,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDk5NTA0MTY=",
    name: "restful_blog_app",
    full_name: "nfragiskatos/restful_blog_app",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/restful_blog_app",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/restful_blog_app",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/restful_blog_app/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/restful_blog_app/deployments",
    created_at: "2018-09-23T05:19:18Z",
    updated_at: "2018-09-23T17:30:03Z",
    pushed_at: "2018-09-23T17:30:02Z",
    git_url: "git://github.com/nfragiskatos/restful_blog_app.git",
    ssh_url: "git@github.com:nfragiskatos/restful_blog_app.git",
    clone_url: "https://github.com/nfragiskatos/restful_blog_app.git",
    svn_url: "https://github.com/nfragiskatos/restful_blog_app",
    homepage: null,
    size: 11,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 708314192,
    node_id: "R_kgDOKjgEUA",
    name: "ResultsFromActivities",
    full_name: "nfragiskatos/ResultsFromActivities",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/ResultsFromActivities",
    description:
      "Sample project to accompany my article on how to receive results from Activities in Android",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/ResultsFromActivities",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/ResultsFromActivities/deployments",
    created_at: "2023-10-22T07:16:20Z",
    updated_at: "2023-11-16T14:12:48Z",
    pushed_at: "2023-11-06T21:19:51Z",
    git_url: "git://github.com/nfragiskatos/ResultsFromActivities.git",
    ssh_url: "git@github.com:nfragiskatos/ResultsFromActivities.git",
    clone_url: "https://github.com/nfragiskatos/ResultsFromActivities.git",
    svn_url: "https://github.com/nfragiskatos/ResultsFromActivities",
    homepage:
      "https://blog.nicholasfragiskatos.dev/starting-activities-for-results-in-android",
    size: 104,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "android",
      "android-activity",
      "android-development",
      "android-framework",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 634740769,
    node_id: "R_kgDOJdVgIQ",
    name: "Rewind",
    full_name: "nfragiskatos/Rewind",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/Rewind",
    description: "Film journal app",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/Rewind",
    forks_url: "https://api.github.com/repos/nfragiskatos/Rewind/forks",
    keys_url: "https://api.github.com/repos/nfragiskatos/Rewind/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/Rewind/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/Rewind/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/Rewind/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/Rewind/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/statuses/{sha}",
    languages_url: "https://api.github.com/repos/nfragiskatos/Rewind/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/Rewind/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/nfragiskatos/Rewind/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Rewind/deployments",
    created_at: "2023-05-01T04:04:35Z",
    updated_at: "2023-05-01T04:04:45Z",
    pushed_at: "2023-05-23T02:41:43Z",
    git_url: "git://github.com/nfragiskatos/Rewind.git",
    ssh_url: "git@github.com:nfragiskatos/Rewind.git",
    clone_url: "https://github.com/nfragiskatos/Rewind.git",
    svn_url: "https://github.com/nfragiskatos/Rewind",
    homepage: null,
    size: 196,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 504619391,
    node_id: "R_kgDOHhPhfw",
    name: "Signal-Android",
    full_name: "nfragiskatos/Signal-Android",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/Signal-Android",
    description: "A private messenger for Android.",
    fork: true,
    url: "https://api.github.com/repos/nfragiskatos/Signal-Android",
    forks_url: "https://api.github.com/repos/nfragiskatos/Signal-Android/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/Signal-Android/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/Signal-Android/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/Signal-Android/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/Signal-Android/deployments",
    created_at: "2022-06-17T17:26:21Z",
    updated_at: "2023-10-11T08:32:08Z",
    pushed_at: "2023-10-11T08:31:34Z",
    git_url: "git://github.com/nfragiskatos/Signal-Android.git",
    ssh_url: "git@github.com:nfragiskatos/Signal-Android.git",
    clone_url: "https://github.com/nfragiskatos/Signal-Android.git",
    svn_url: "https://github.com/nfragiskatos/Signal-Android",
    homepage: "https://signal.org",
    size: 1126439,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Java",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "agpl-3.0",
      name: "GNU Affero General Public License v3.0",
      spdx_id: "AGPL-3.0",
      url: "https://api.github.com/licenses/agpl-3.0",
      node_id: "MDc6TGljZW5zZTE=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 721709339,
    node_id: "R_kgDOKwRpGw",
    name: "SimpleDataStorageInAndroid",
    full_name: "nfragiskatos/SimpleDataStorageInAndroid",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/SimpleDataStorageInAndroid",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/SimpleDataStorageInAndroid/deployments",
    created_at: "2023-11-21T16:02:44Z",
    updated_at: "2023-11-24T16:36:51Z",
    pushed_at: "2023-11-24T16:35:27Z",
    git_url: "git://github.com/nfragiskatos/SimpleDataStorageInAndroid.git",
    ssh_url: "git@github.com:nfragiskatos/SimpleDataStorageInAndroid.git",
    clone_url: "https://github.com/nfragiskatos/SimpleDataStorageInAndroid.git",
    svn_url: "https://github.com/nfragiskatos/SimpleDataStorageInAndroid",
    homepage: null,
    size: 111,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 257020039,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTcwMjAwMzk=",
    name: "SleepTracker-MVVM-Room",
    full_name: "nfragiskatos/SleepTracker-MVVM-Room",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/SleepTracker-MVVM-Room",
    description:
      "Practice app to track sleep that utilizes MVVM arhcitecture and uses Room to help persist on the backend.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room/deployments",
    created_at: "2020-04-19T14:26:51Z",
    updated_at: "2020-04-20T00:56:00Z",
    pushed_at: "2020-04-20T00:55:58Z",
    git_url: "git://github.com/nfragiskatos/SleepTracker-MVVM-Room.git",
    ssh_url: "git@github.com:nfragiskatos/SleepTracker-MVVM-Room.git",
    clone_url: "https://github.com/nfragiskatos/SleepTracker-MVVM-Room.git",
    svn_url: "https://github.com/nfragiskatos/SleepTracker-MVVM-Room",
    homepage: null,
    size: 451,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 257379859,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTczNzk4NTk=",
    name: "SleepTracker-MVVM-Room-RecyclerView",
    full_name: "nfragiskatos/SleepTracker-MVVM-Room-RecyclerView",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url:
      "https://github.com/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView",
    description:
      "Practice app to track sleep that utilizes MVVM arhcitecture and uses Room to help persist on the backend.",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView/deployments",
    created_at: "2020-04-20T19:12:29Z",
    updated_at: "2020-04-25T15:04:08Z",
    pushed_at: "2020-04-25T15:04:06Z",
    git_url:
      "git://github.com/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView.git",
    ssh_url:
      "git@github.com:nfragiskatos/SleepTracker-MVVM-Room-RecyclerView.git",
    clone_url:
      "https://github.com/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView.git",
    svn_url:
      "https://github.com/nfragiskatos/SleepTracker-MVVM-Room-RecyclerView",
    homepage: null,
    size: 503,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 353529696,
    node_id: "MDEwOlJlcG9zaXRvcnkzNTM1Mjk2OTY=",
    name: "StackOverflowBrowswerWithDagger2",
    full_name: "nfragiskatos/StackOverflowBrowswerWithDagger2",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url:
      "https://github.com/nfragiskatos/StackOverflowBrowswerWithDagger2",
    description: "Toy app to learn Dagger 2 and some Hilt",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/StackOverflowBrowswerWithDagger2/deployments",
    created_at: "2021-04-01T00:47:33Z",
    updated_at: "2021-04-15T15:23:31Z",
    pushed_at: "2021-04-15T23:23:22Z",
    git_url:
      "git://github.com/nfragiskatos/StackOverflowBrowswerWithDagger2.git",
    ssh_url: "git@github.com:nfragiskatos/StackOverflowBrowswerWithDagger2.git",
    clone_url:
      "https://github.com/nfragiskatos/StackOverflowBrowswerWithDagger2.git",
    svn_url: "https://github.com/nfragiskatos/StackOverflowBrowswerWithDagger2",
    homepage: null,
    size: 262,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 481044682,
    node_id: "R_kgDOHKwoyg",
    name: "StockMarketViewer",
    full_name: "nfragiskatos/StockMarketViewer",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/StockMarketViewer",
    description:
      "Toy App for practicing Android development. Specifically new Compose library",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/StockMarketViewer",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/StockMarketViewer/deployments",
    created_at: "2022-04-13T02:35:47Z",
    updated_at: "2023-07-05T03:14:16Z",
    pushed_at: "2022-04-16T18:17:57Z",
    git_url: "git://github.com/nfragiskatos/StockMarketViewer.git",
    ssh_url: "git@github.com:nfragiskatos/StockMarketViewer.git",
    clone_url: "https://github.com/nfragiskatos/StockMarketViewer.git",
    svn_url: "https://github.com/nfragiskatos/StockMarketViewer",
    homepage: "",
    size: 141,
    stargazers_count: 1,
    watchers_count: 1,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "android",
      "android-application",
      "android-development",
      "compose-android",
      "composer-library",
      "coroutines",
      "coroutines-android",
      "coroutines-flow",
      "kotlin",
      "kotlin-android",
      "mvvm",
      "mvvm-android",
      "mvvm-architecture",
      "retrofit",
      "retrofit2",
      "retrofit2-coroutines",
      "retrofit2-kotlin",
      "room",
      "room-database",
      "roomdatabase",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: "master",
  },
  {
    id: 149646826,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDk2NDY4MjY=",
    name: "testRepo",
    full_name: "nfragiskatos/testRepo",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/testRepo",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/testRepo",
    forks_url: "https://api.github.com/repos/nfragiskatos/testRepo/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/testRepo/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/testRepo/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/testRepo/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/testRepo/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/testRepo/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/testRepo/deployments",
    created_at: "2018-09-20T17:36:47Z",
    updated_at: "2018-09-20T17:55:09Z",
    pushed_at: "2018-09-20T17:55:07Z",
    git_url: "git://github.com/nfragiskatos/testRepo.git",
    ssh_url: "git@github.com:nfragiskatos/testRepo.git",
    clone_url: "https://github.com/nfragiskatos/testRepo.git",
    svn_url: "https://github.com/nfragiskatos/testRepo",
    homepage: null,
    size: 1,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 407985726,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDc5ODU3MjY=",
    name: "TMDBClient_Class",
    full_name: "nfragiskatos/TMDBClient_Class",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/TMDBClient_Class",
    description:
      "Toy Android app for browsing movie/tv show information. Following MVVM & Clean Architecture, and using Dagger, Retrofit, Room, Coroutines, and Data Binding",
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/TMDBClient_Class",
    forks_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/teams",
    hooks_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/TMDBClient_Class/deployments",
    created_at: "2021-09-18T23:05:23Z",
    updated_at: "2021-10-09T14:12:44Z",
    pushed_at: "2021-10-09T14:12:41Z",
    git_url: "git://github.com/nfragiskatos/TMDBClient_Class.git",
    ssh_url: "git@github.com:nfragiskatos/TMDBClient_Class.git",
    clone_url: "https://github.com/nfragiskatos/TMDBClient_Class.git",
    svn_url: "https://github.com/nfragiskatos/TMDBClient_Class",
    homepage: "",
    size: 161,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Kotlin",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      "clean-architecture",
      "coroutines",
      "coroutines-android",
      "dagger2",
      "dagger2-android",
      "data-binding",
      "databinding-android",
      "mvvm",
      "mvvm-android",
      "mvvm-architecture",
      "retrofit",
      "retrofit2-kotlin",
      "room-persistence-library",
    ],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 548409107,
    node_id: "R_kgDOILAPEw",
    name: "web-scraper",
    full_name: "nfragiskatos/web-scraper",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/web-scraper",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/web-scraper",
    forks_url: "https://api.github.com/repos/nfragiskatos/web-scraper/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/web-scraper/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/web-scraper/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/web-scraper/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/web-scraper/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/web-scraper/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/web-scraper/deployments",
    created_at: "2022-10-09T14:08:10Z",
    updated_at: "2022-10-09T15:47:15Z",
    pushed_at: "2022-10-09T15:47:11Z",
    git_url: "git://github.com/nfragiskatos/web-scraper.git",
    ssh_url: "git@github.com:nfragiskatos/web-scraper.git",
    clone_url: "https://github.com/nfragiskatos/web-scraper.git",
    svn_url: "https://github.com/nfragiskatos/web-scraper",
    homepage: null,
    size: 1404,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 149846119,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDk4NDYxMTk=",
    name: "YelpCamp",
    full_name: "nfragiskatos/YelpCamp",
    private: false,
    owner: {
      login: "nfragiskatos",
      id: 38383279,
      node_id: "MDQ6VXNlcjM4MzgzMjc5",
      avatar_url: "https://avatars.githubusercontent.com/u/38383279?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/nfragiskatos",
      html_url: "https://github.com/nfragiskatos",
      followers_url: "https://api.github.com/users/nfragiskatos/followers",
      following_url:
        "https://api.github.com/users/nfragiskatos/following{/other_user}",
      gists_url: "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/nfragiskatos/subscriptions",
      organizations_url: "https://api.github.com/users/nfragiskatos/orgs",
      repos_url: "https://api.github.com/users/nfragiskatos/repos",
      events_url: "https://api.github.com/users/nfragiskatos/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/nfragiskatos/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/nfragiskatos/YelpCamp",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/nfragiskatos/YelpCamp",
    forks_url: "https://api.github.com/repos/nfragiskatos/YelpCamp/forks",
    keys_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/nfragiskatos/YelpCamp/teams",
    hooks_url: "https://api.github.com/repos/nfragiskatos/YelpCamp/hooks",
    issue_events_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/issues/events{/number}",
    events_url: "https://api.github.com/repos/nfragiskatos/YelpCamp/events",
    assignees_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/branches{/branch}",
    tags_url: "https://api.github.com/repos/nfragiskatos/YelpCamp/tags",
    blobs_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/languages",
    stargazers_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/stargazers",
    contributors_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/contributors",
    subscribers_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/subscribers",
    subscription_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/subscription",
    commits_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/nfragiskatos/YelpCamp/merges",
    archive_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/downloads",
    issues_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/labels{/name}",
    releases_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/nfragiskatos/YelpCamp/deployments",
    created_at: "2018-09-22T04:45:23Z",
    updated_at: "2018-09-30T14:49:48Z",
    pushed_at: "2018-09-30T14:49:47Z",
    git_url: "git://github.com/nfragiskatos/YelpCamp.git",
    ssh_url: "git@github.com:nfragiskatos/YelpCamp.git",
    clone_url: "https://github.com/nfragiskatos/YelpCamp.git",
    svn_url: "https://github.com/nfragiskatos/YelpCamp",
    homepage: null,
    size: 48,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
];
